import WagglesApp from "./WagglesApp";

export default function App() {
  return <WagglesApp />;
}
